import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Delete, Edit } from '@mui/icons-material';
import { ColumnContainer } from '../../utils/columnsStyle';
import { 
  editContractConditionMode,
  contractConditionSelected,
  deleteContractConditionMode
} from '../../redux/actions/contractsConditionsCatalog/contractsConditionsCatalogActions';

const style = {
  color: '#004F9F',
  fontSize: 20,
  marginRight: 10,
  cursor: 'pointer'
};

const acciones = {
  Header: () => (<span style={{ fontSize: '.8rem' }}>Acciones</span>),
  filterable: false,
  sortable: false,
  Cell: ({ original }) => {
    const dispatch = useDispatch();
    const openEdit = () => {
      dispatch(editContractConditionMode());
      original.modal();
      dispatch(contractConditionSelected(original.id));
    };
    const openEliminate = () => {
      dispatch(deleteContractConditionMode());
      original.modal();
      dispatch(contractConditionSelected(original.id));
    };
    const { addContract } = useSelector(state => state.contractsCatalog);
    return (
      <ColumnContainer>
        <Edit style={style} onClick={openEdit}/>
        {
          addContract && <Delete style={{ ...style,  color: '#e83737'}} onClick={openEliminate}/>
        }
      </ColumnContainer>
    )
  },
}

export const columns1 = [
  {
    Header: () => (<span style={{ fontSize: '.8rem' }}>Tipo de empleado</span>),
    accessor: "employeeTypeTbl",
    filterable: true,
    filterMethod: (filter, row) =>
      row.employeeTypeTbl
        ? row.employeeTypeTbl.toLowerCase().includes(filter.value.toLowerCase())
        : "",
  },
  {
    Header: () => (<span style={{ fontSize: '.8rem' }}>Sucursal</span>),
    accessor: "branchOfficeTbl",
    filterable: true,
    filterMethod: (filter, row) =>
      row.branchOfficeTbl
        ? row.branchOfficeTbl.toLowerCase().includes(filter.value.toLowerCase())
        : "",
  },
  {
    Header: () => (<span style={{ fontSize: '.8rem' }}>Centro de Costos</span>),
    accessor: "costCenter",
    filterable: true,
    filterMethod: (filter, row) =>
      row.costCenter
        ? row.costCenter.toLowerCase().includes(filter.value.toLowerCase())
        : "",
  },
  {
    Header: () => (<span style={{ fontSize: '.8rem' }}>Operaciones de destajo</span>),
    accessor: "pieceworkTbl",
    filterable: true,
    filterMethod: (filter, row) =>
      row.pieceworkTbl
        ? row.pieceworkTbl.toLowerCase().includes(filter.value.toLowerCase())
        : "",
  },
  {
    Header: () => (<span style={{ fontSize: '.8rem' }}>Periodo de cálculo</span>),
    accessor: "periodTbl",
    filterable: true,
    filterMethod: (filter, row) =>
      row.periodTbl
        ? row.periodTbl.toLowerCase().includes(filter.value.toLowerCase())
        : "",
  },
  {
    Header: () => (<span style={{ fontSize: '.8rem' }}>Venta base del cálculo</span>),
    accessor: "baseSaleTbl",
    filterable: true,
    filterMethod: (filter, row) =>
      row.baseSaleTbl
        ? row.baseSaleTbl.toLowerCase().includes(filter.value.toLowerCase())
        : "",
  },
  acciones
];

export const columns2 = [
  {
    Header: () => (<span style={{ fontSize: '.8rem' }}>Contado/Crédito</span>),
    accessor: "typeSaleTbl",
    filterable: true,
    filterMethod: (filter, row) =>
      row.typeSaleTbl
        ? row.typeSaleTbl.toLowerCase().includes(filter.value.toLowerCase())
        : "",
  },
  {
    Header: () => (<span style={{ fontSize: '.8rem' }}>Ruta</span>),
    accessor: "routeTbl",
    filterable: true,
    filterMethod: (filter, row) =>
      row.routeTbl
        ? row.routeTbl.toLowerCase().includes(filter.value.toLowerCase())
        : "",
  },
  {
    Header: () => (<span style={{ fontSize: '.8rem' }}>Temporada de Año</span>),
    accessor: "seasonTbl",
    filterable: true,
    filterMethod: (filter, row) =>
      row.seasonTbl
        ? row.seasonTbl.toLowerCase().includes(filter.value.toLowerCase())
        : "",
  },
  {
    Header: () => (<span style={{ fontSize: '.8rem' }}>Tipo de cliente</span>),
    accessor: "customerTypeTbl",
    filterable: true,
    filterMethod: (filter, row) =>
      row.customerTypeTbl
        ? row.customerTypeTbl.toLowerCase().includes(filter.value.toLowerCase())
        : "",
  },
  {
    Header: () => (<span style={{ fontSize: '.8rem' }}>Traspasos/Mayoreo</span>),
    accessor: "transferTypeTbl",
    filterable: true,
    filterMethod: (filter, row) =>
      row.transferTypeTbl
        ? row.transferTypeTbl.toLowerCase().includes(filter.value.toLowerCase())
        : "",
  },
  {
    Header: () => (<span style={{ fontSize: '.8rem' }}>Uso de Tabulador</span>),
    accessor: "tabulatorTbl",
    filterable: true,
    filterMethod: (filter, row) =>
      row.tabulatorTbl
        ? row.tabulatorTbl.toLowerCase().includes(filter.value.toLowerCase())
        : "",
  },
  {
    Header: () => (<span style={{ fontSize: '.8rem' }}>Futuro</span>),
    accessor: "futureTbl",
    filterable: true,
    filterMethod: (filter, row) =>
      row.futureTbl
        ? row.futureTbl.toLowerCase().includes(filter.value.toLowerCase())
        : "",
  },
  acciones
];